export class BulkEmailTemplate {
	constructor(public Id: number, public Name: string) {
	}
}